module.exports = __webpack_public_path__ + "static/media/logotrimap.505dbf6c.jpg";